package com.islamicmedia.shared.data.api

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
data class ApiRequest(
    val model: String,
    @SerialName("max_tokens") val maxTokens: Int,
    val messages: List<ApiMessage>,
    val tools: List<ApiTool>? = null
)

@Serializable
data class ApiMessage(
    val role: String,
    val content: String
)

@Serializable
data class ApiTool(
    val type: String,
    val name: String
)

@Serializable
data class ApiResponse(
    val content: List<ContentBlock> = emptyList(),
    val usage: ApiUsage? = null
)

@Serializable
data class ApiUsage(
    @SerialName("input_tokens") val inputTokens: Int = 0,
    @SerialName("output_tokens") val outputTokens: Int = 0,
    @SerialName("cache_creation_input_tokens") val cacheCreationInputTokens: Int = 0,
    @SerialName("cache_read_input_tokens") val cacheReadInputTokens: Int = 0
)

@Serializable
data class ContentBlock(
    val type: String,
    val text: String? = null
)

@Serializable
data class ErrorReportRequest(
    val userMessage: String = "",
    val errorDetails: String = "",
    val title: String = "",
    val userEmail: String? = null,
    val appVersion: String? = null,
    val platform: String? = null
)

/** A user-submitted flag on a problematic analysis. Stored server-side and surfaced in the admin dashboard. */
@Serializable
data class FlagAnalysisRequest(
    val title: String = "",
    val mediaType: String? = null,
    val score: Int? = null,
    val quickCheck: Boolean = false,
    /** Optional free-text note from the user explaining what's wrong. */
    val message: String = "",
    /** JSON-encoded SearchCriteria the user had selected, so a resolve can re-run faithfully. */
    val criteriaJson: String? = null,
    val userEmail: String? = null,
    val appVersion: String? = null,
    val platform: String? = null
)
